export const GET_CURRENT_EXPERIENCES = "GET_CURRENT_EXPERIENCES";
export const REFRESH_CURRENT_EXPERIENCES = "REFRESH_CURRENT_EXPERIENCES";
export const RESET_CURRENT_EXPERIENCES = "RESET_CURRENT_EXPERIENCES";
export const SET_CURRENT_EXPERIENCES_REQUEST_STATUS = "SET_CURRENT_EXPERIENCES_REQUEST_STATUS";
